import { GameTypeAbstract } from "../GameTypeAbstract";

export class TournamentTypeAbstract extends GameTypeAbstract {
}
